const INITIAL_STATE = {
    motivosdesistencia: [],
    motivodesistencia: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'DESISTENCIAS_FETCHED':
        return { ...state, motivosdesistencia: action.payload }
        case 'DESISTENCIA_FETCHED':
        return { ...state, motivodesistencia: action.payload }
      default:
        return state
    }
  }